import t, { plural } from "@repo/localization/string.macro";
import { Promotion as CanadaPromotionPb } from "@repo/protobuf/gen/kikoff_canada/protobuf/models/promotions/promotion_pb";
import { MessageFrom } from "@repo/protobuf/utils";
import Case from "@repo/utils/Case";
import Enum from "@repo/utils/Enum";
import Money from "@repo/utils/Money";

import Subscription, { SubscriptionCanada } from "./Subscription";

type Promotion = {
  amount: number;
  unit: Promotion.Unit;
  monthsLeft: number;
  validTiers: Subscription.Tier[];
};

namespace Promotion {
  export type Id = string & {};

  export type Unit = "cents" | "percent";

  export function description(
    tier: Subscription.Tier,
    promotion: Promotion
  ): string | undefined {
    if (!promotion || !promotion.validTiers.includes(tier)) return;

    const value = (() => {
      if (promotion.unit === "cents") {
        return Money.format(promotion.amount);
      } else if (promotion.unit === "percent") {
        return promotion.amount.toString() + "%";
      }
    })();

    return t`${value} off for ${promotion.monthsLeft} ${plural(
      promotion.monthsLeft,
      {
        one: "month",
        other: "months",
      }
    )}`;
  }

  export function discountedValue(
    cents: number,
    promotion: Promotion
  ): number | undefined {
    let discountedCents = cents;
    if (promotion.unit === "cents") {
      discountedCents = cents - promotion.amount;
    } else if (promotion.unit === "percent") {
      discountedCents = cents - cents * (promotion.amount / 100);
    }
    return discountedCents;
  }
}

export default Promotion;

export namespace PromotionCanada {
  export function normalize(
    promotion: MessageFrom<CanadaPromotionPb>
  ): Promotion {
    const unit = Case.fromConstant(
      Enum.keyOf(CanadaPromotionPb.Unit, promotion.unit)
    ).toCamel();

    if (unit === "unknown")
      throw new Error("Unexpected UNKNOWN unit in promotion.");

    return {
      unit: unit,
      amount: promotion.amount,
      monthsLeft: promotion.monthsLeft,
      validTiers: promotion.validTiers.map(
        SubscriptionCanada.Plan.Tier.normalize
      ),
    };
  }
}
